// src/App.tsx
import { ThemeProvider, CssBaseline, IconButton } from "@mui/material";
import { useState } from "react";
import { lightTheme, darkTheme } from "./theme/themes";
import { AuthProvider } from "./contexts/AuthContext";
import AppRoutes from "./routes/AppRoutes";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { SnackbarProvider } from "./components/KenSnackbar";
import { LoaderProvider } from "./components/KenLoader";
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from "./utils/ErrorBoundary";


export default function App() {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
        window.location.reload();
      }}
    >
      <AuthProvider>
        <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
          <SnackbarProvider>

            <CssBaseline />
            {/* <div style={{ position: "absolute", bottom: 10, right: 10 }}>
                <IconButton onClick={() => setDarkMode(!darkMode)} color="inherit">
                  {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
                </IconButton>
              </div> */}
            <LoaderProvider>
              <AppRoutes />
            </LoaderProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}
